export default {
  GET_DATA_LIST: '/manage/img-config/findList',
  UPDATE_DATA: '/manage/img-config/update',
  GET_DETAIL: '/manage/img-config/find',
  GET_BRAND_LIST: '/auth/brand/select',
  GET_CONCETP_LIST: '/auth/concept/findFilterByKeyword',
  GET_FORMULATION_LIST:'/auth/formulation/findList',
  GET_CONSUMER_PRODUCT:'/auth/product/productList',
  GET_EVENT_LIST: '/manage/event/selectByName',
  GET_BASF_PRODUCT: '/auth/trade/getBasfProductsByName',
  GET_INCI: '/app/trade/inci/findInci',
  GET_TREND: '/auth/trend/findFilterByKeyword',
  GET_WEBINAR: '/auth/webinar/findFilterByKeyword',
  CHANGE_STATUS: '/manage/img-config/hiddenBanner',
  ADD_BANNER: '/manage/img-config/saveBanner',
  SET_WEIGHT: '/manage/img-config/setWeight',
  CHECK_WEIGHT: '/manage/img-config/checkWeight',
  DELETE_WEB_BANNER: '/manage/img-config/delete',
  GET_BANNER_COUNT: '/manage/img-config/countBanner'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/appPictures.js